import { useState } from "react";
import useProductStore from "../Stores/useProductStore";

export const useCategorySelection = () => {
  const { getProducts, getProductsByCategoryOrFriendlyName } =
    useProductStore();
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategorySelect = async (category) => {    

    console.log("Selected category: ", category?.Value);
    setSelectedCategory(category);
    if (category == null) {
      window.history.replaceState(null, "", `/Products`);
      await getProducts();
      return;
    }

    window.history.replaceState(null, "", `/Products/${category.FriendlyName}`);
    await getProductsByCategoryOrFriendlyName(category.FriendlyName);
    // You can add additional logic here to filter products based on the selected category
  };

  const setSelectedCategoryFromUrl = (category) => {
    setSelectedCategory(category);
  };

  return {
    selectedCategory,
    handleCategorySelect,
    setSelectedCategoryFromUrl,
  };
};

// const handleCategorySelect = async (category) => {
//   console.log("Selected category: ", category?.Value);
//   setSelectedCategory(category);
//   if (category == null){
//        window.history.replaceState(
//   null,
//   "",
//   `/Products`
// );
//     await getProducts();
//       return;
//   }

//     window.history.replaceState(
//   null,
//   "",
//   `/Products/${category.FriendlyName}`
// );
//   await getProductsByCategoryOrFriendlyName(category.FriendlyName);
//   // You can add additional logic here to filter products based on the selected category
// };
